<div class="main-loading">
  <app-spinner [loading]="true"></app-spinner>
  <h4>{{ 'LOADING.TEXT' | translate }}</h4>
</div>